import type { EmblaCarouselType } from 'embla-carousel';
import type { AutoplayType } from 'embla-carousel-autoplay';

export const emblaPluginAutoplay = (emblaApi: EmblaCarouselType, buttons: HTMLElement[]) => {
  const autoplay = emblaApi.plugins().autoplay as AutoplayType | undefined;
  if (!autoplay) return;
  autoplay.play();

  /**
   * Button Click時に自動再生をリセット
   */
  if (buttons.length > 0) {
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        autoplay.reset();
      });
    });
  }
}